import { render } from "./RightToErasureForm.vue?vue&type=template&id=66894eb4&ts=true"
import script from "./RightToErasureForm.vue?vue&type=script&lang=ts"
export * from "./RightToErasureForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/Profile/RightToErasureForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66894eb4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66894eb4', __exports__)) {
    api.reload('66894eb4', __exports__)
  }
  
  module.hot.accept("./RightToErasureForm.vue?vue&type=template&id=66894eb4&ts=true", () => {
    api.rerender('66894eb4', render)
  })

}


export default __exports__